import { useMemo, useState } from "react";
import { RoundedBoxGeometry } from "three/examples/jsm/geometries/RoundedBoxGeometry";
import { useCabinetStore } from "../../../context/StoreContext";
import { getDimensions } from "../../../hooks/getDimensions";
import { useMaterialContext } from "../context/MaterialContext";
import { CORNER_SMOOTHING, getCornerRounding } from "../data";
import type { Vertical as VerticalType } from "../data/Vertical";

interface Props {
	vertical: VerticalType;
}

export function Vertical({ vertical }: Props) {
	const { getMaterial } = useMaterialContext();
	const { state, api } = useCabinetStore();
	const cornerRounding: number = getCornerRounding(state, api);
	const [hover, setHover] = useState(false);

	const geometry = useMemo(() => {
		const dimensions = getDimensions(vertical);
		return new RoundedBoxGeometry(
			dimensions.width,
			dimensions.height,
			dimensions.depth,
			CORNER_SMOOTHING,
			cornerRounding,
		);
	}, [vertical, cornerRounding]);

	const material = getMaterial({
		variant: "vertical",
		width: vertical.width,
		height: vertical.height,
		depth: vertical.depth,
		hover,
	});

	return (
		// biome-ignore lint/a11y/useKeyWithClickEvents: no need for key event
		<mesh
			name={vertical.id}
			onClick={() => {
				console.info("Vertical", vertical);
			}}
			receiveShadow
			castShadow
			position={[
				(vertical.x + vertical.height / 2) / 1000,
				(vertical.y + vertical.width / 2) / 1000,
				(vertical.z + vertical.depth / 2) / 1000,
			]}
			rotation={[0, 0, Math.PI / 2]}
			onPointerOver={(evt) => {
				setHover(true);
				evt.stopPropagation();
			}}
			onPointerOut={(evt) => {
				setHover(false);
				evt.stopPropagation();
			}}
			material={material}
			geometry={geometry}
		/>
	);
}
